// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1-Kwb","title":"Header_title__JXiBl","side":"Header_side__1gDQW"};